<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, Sidekick } from '#library/components.schema.build.ts'
	import Copy from '#components/copy.svelte'
	import Figure from '#components/figure.svelte'

	interface Props {
		blok: Blok<Sidekick>
		div?: boolean
		pagpad?: boolean
	}

	let { blok: rawBlok, div, pagpad }: Props = $props()

	// https://svelte.dev/docs/svelte/compiler-warnings#state_referenced_locally
	const blok = $derived({
		...rawBlok,
		padding_top: rawBlok.padding_top ?? '0',
		padding_bottom: rawBlok.padding_bottom ?? '0'
	})
</script>

<svelte:element
	this={div ? 'div' : 'section'}
	class="sidekick {blok.theme || 'theme-crocus-on-light-gimson'}"
	{...{ ...attrs(blok), id: blok.anchor || blok.id || undefined }}
>
	<div class="contain {blok.split ? `split-${blok.split}` : ''}" class:flip={blok.flip}>
		{#if blok.embed}
			<div class="embed">{@html blok.embed}</div>
		{:else if blok.video?.m3u8_url || blok.image?.filename}
			<Figure
				shape={blok.shape}
				image={blok.image}
				overlay={blok.overlay}
				aspect={blok.aspect}
				flip={blok.flip}
				shrink={blok.shrink}
				fill={blok.fill}
				video={blok.video}
			/>
		{/if}
		<Copy
			title={blok.title}
			subtitle={blok.subtitle}
			body={blok.body}
			size={blok.titlesize}
			plain={blok.titleplain}
			split={!blok.image?.filename && !blok.together && !blok.embed}
			flip={blok.flip && !blok.image?.filename && !blok.video?.m3u8_url}
			pad={pagpad}
		/>
	</div>
</svelte:element>

<style lang="css">
	.embed {
		order: 1;
	}

	.sidekick {
		background-color: var(--c-background);
		color: var(--c-foreground);
	}

	.contain {
		display: grid;
		gap: 2rem;
		padding-block: var(--padding-top, var(--padding-default)) var(--padding-bottom, var(--padding-default));

		@media (--from-mobile) {
			gap: 2rem;
			grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);

			&.split-4 {
				grid-template-columns: minmax(0, 8fr) minmax(0, 4fr);

				&.flip {
					grid-template-columns: minmax(0, 4fr) minmax(0, 8fr);
				}
			}

			&.split-5 {
				grid-template-columns: minmax(0, 7fr) minmax(0, 5fr);

				&.flip {
					grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
				}
			}

			&.split-7 {
				grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);

				&.flip {
					grid-template-columns: minmax(0, 7fr) minmax(0, 5fr);
				}
			}

			&.split-8 {
				grid-template-columns: minmax(0, 4fr) minmax(0, 8fr);

				&.flip {
					grid-template-columns: minmax(0, 8fr) minmax(0, 4fr);
				}
			}
		}
	}
</style>
